import industries from "./industryWorkflows.json";
import starters from "./missionStarterCatalog.json";
import collection from "./missionTemplateSummary.json";

export const LOCATION_AVAILABILITY_SNAPSHOT = {
  catalogVersion: "geonames:2026-06-22",
  sourceSnapshot: "2026-06-22",
  cityRecords: 21_166,
  geographies: 218,
} as const;

export const EQUIPMENT_CATALOG_SNAPSHOT = {
  catalogVersion: "2026-08-15.v2",
  droneModels: 265,
  manufacturers: 44,
} as const;

/** Intentionally published reusable starters; excludes personal, recovered and fixture records. */
export const MISSION_TEMPLATE_CATALOG_SNAPSHOT = {
  reviewedOn: "2026-10-19",
  sourceCommit: starters.sourceCommit,
  sourceSha256: starters.sourceSha256,
  templateIds: starters.templates.map(({ id }) => `catalogue-dronejob-${id}`),
} as const;

export const METRIC_COUNTING_EVIDENCE = {
  reviewedOn: "2026-10-19",
  industries: "Distinct industryWorkflows contexts with scenario, workflow and deliverable guidance; not mission folders.",
  templates: "Unique authored starters in missionStarterCatalog with capture, evidence, review and a reusable preparation-to-delivery checklist; excludes synthetic, personal and recovered content.",
  models: "Distinct drone entries in the combined equipment catalog after curated key and normalized manufacturer/model deduplication; catalog inclusion is not flight-control compatibility.",
  cities: "Active, unsuppressed unique GeoNames populated-place IDs in geonames:2026-06-22. US/CA population >=5000; elsewhere >=40000, or national/first-order capitals >=10000. Not service coverage.",
  geographies: "Unique countryCode values with at least one included city in that same snapshot; includes territories. Not regulatory coverage or residency commitments.",
  locationRowsSha256: "3bb7896766353541c58a94df9940faa403da7c58901021a570d4a0ab3d5b3971",
  equipmentSourceSha256: "061e7208f9eed9ee6c3fa5a7f3387530a4939e7c633b963f2207f3817ef298e6",
} as const;

type ConfidenceMetric = Readonly<{
  key: "industries" | "templates" | "models" | "cities" | "geographies";
  value: number;
  href: string;
}>;

export const HOME_CONFIDENCE_METRICS: readonly ConfidenceMetric[] = [
  { key: "industries", value: Object.keys(industries).length, href: "/solutions/industries" },
  { key: "templates", value: collection.publicCount, href: "/resources/templates" },
  { key: "models", value: EQUIPMENT_CATALOG_SNAPSHOT.droneModels, href: "/platform#teams-scheduling-fleet" },
  { key: "cities", value: LOCATION_AVAILABILITY_SNAPSHOT.cityRecords, href: "/enterprise/governance#geo-data-readiness" },
  { key: "geographies", value: LOCATION_AVAILABILITY_SNAPSHOT.geographies, href: "/enterprise/governance#geo-data-readiness" },
] as const;
